export const formatCurrency = (num: number, options?: Intl.NumberFormatOptions): string => {
  // TrailingZeroDisplay is not supported by node 18 so we handle it manually.
  const { trailingZeroDisplay, ...otherRealOptions } = options || {};

  const locale = 'en-US';
  const defaultCurrency = 'USD';

  const formatterOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: defaultCurrency,
    ...otherRealOptions,
  };

  const formatter = new Intl.NumberFormat(locale, formatterOptions);
  
  let formattedNum = formatter.format(num);

  if (trailingZeroDisplay === 'stripIfInteger' && num % 1 === 0) {
    const parts = formatter.formatToParts(num);
    
    const decimalPart = parts.find(part => part.type === 'decimal');
    const fractionPart = parts.find(part => part.type === 'fraction');

    if (decimalPart && fractionPart && /^[0]+$/.test(fractionPart.value)) {
      const stringToRemove = decimalPart.value + fractionPart.value;
      if (formattedNum.endsWith(stringToRemove)) {
        formattedNum = formattedNum.substring(0, formattedNum.length - stringToRemove.length);
      }
    }
  }

  return formattedNum;
};

export const sanitizeWithDashes = (txt: string): string => {
  if(txt !== undefined) {
    return txt
      .trim()
      .toLowerCase()
      .replace(/[^\s\w]/g, '')
      .replace(/\s\s/g, ' ')
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  } else {
    return '';
  }
};
